/* Cicabelle cart 2.0 (2026-09-29, owner-approved boards Proposed /
   ProposedMobile / ProposedMobileAR) — the order-summary card's live
   behaviours around the theme's own redraw contract:
     1) MIRRORS: the Total row, the "Checkout securely · AED X" CTA amount and
        the tabby/tamara "4 × amount" boxes follow the ONE [data-subtotal]
        node theme.js buildCart rewrites (the Total/CTA mirror its formatted
        text verbatim — zero formatting drift); the Items / free-gifts /
        Delivery rows re-read /cart.js (debounced) like cb-cart-savings does,
        with the gift worths riding as a Liquid-rendered variant->fils map
        (data-worths) so no price logic is duplicated here. The gifts box's
        dashed away-card and Almost-there nudge ride the same read: their
        threshold, base and [amount] template are Liquid-rendered data
        attributes (cb-cart-offers-gift), so a quantity-only theme redraw —
        which keepShelf survives WITHOUT a softRefresh — never leaves a
        stale gap amount beside the fresh summary numbers. A crossed
        threshold (gap <= 0) is left for the frozen rail's settle(), which
        re-renders the whole box server-side on the state flip.
     2) CODE FOLD: the discount box (input #discount-code, Add
        #apply-discount, code chips ul.cart_discounts, the min-spend
        .cb2-min-msgs lines cb2-cards.js inserts, theme.js's p.error) sits
        collapsed behind "Have a discount code?". It AUTO-EXPANDS whenever
        NEW content lands in it — a code chip, a min-spend line, the error —
        so those messages stay visible exactly as today. The engine's own
        message box (.cb2-eng-msg) inserts itself ABOVE the checkout wrapper,
        outside the fold, and is never hidden. The Enter-key flow is
        untouched: cb2-cards.js still turns Enter into the Add click.
     3) RECO NOTES: the cart's "You may also like" row (Cart-collection)
        gets the amber milestone note per card, computed from the card's
        data-price against the shopper's NEXT milestones — thresholds and
        bases read from the offers rail's own data attributes
        (#cb2-offers-rail: ship on the POST-discount base, gift/discount/
        tiers on the PRE-discount base, exactly the rail JS's formulas), so
        there is no duplicate threshold logic. Cards that cross a milestone
        sort first; notes hide when every milestone is done. The shopper's
        cb2_recent recently-viewed handles merge into the same row as
        reduced-opacity cards (the separate rail skips the cart page now).
   Every write is write-if-changed, so the engine's own form observer (and
   ours) never loops on our writes. This file never touches the cart. */
(function () {
  'use strict';
  if (typeof window.fetch !== 'function') return;
  var form = document.getElementById('CartPageForm');
  if (!form) return;
  function rootUrl() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  var marketConfig = window.cbMarketConfig;
  var marketCountry = marketConfig && marketConfig.country;
  var marketOn = marketCountry === 'SA' || marketCountry === 'KW';
  var AMT = /\d[\d,]*(?:\.\d+)?/g;
  function fmt2(v) {
    if (marketCountry === 'KW') return window.cbKwd ? window.cbKwd.presentment(Number(v), marketConfig.currency).replace(/^KWD /, '') : ''; 
    var s = (Math.round(v) / 100).toFixed(2), i = s.indexOf('.');
    return s.slice(0, i).replace(/\B(?=(\d{3})+$)/g, ',') + s.slice(i);
  }
  function fmt0(v) { return fmt2(v).replace(/\.00$/, ''); }
  // engine-style amount rewrite: the LAST numeric token of the element's text,
  // in its own text node — currency affixes, dir attributes, markup untouched
  function setAmt(el, fils) {
    if (!el || fils == null || !isFinite(fils)) return;
    var w = document.createTreeWalker(el, 4), n, node = null, tok = null;
    while ((n = w.nextNode())) {
      AMT.lastIndex = 0;
      var m, last = null;
      while ((m = AMT.exec(n.nodeValue))) last = m;
      if (last) { node = n; tok = last; }
    }
    if (!node) return;
    var v = node.nodeValue;
    var nv = v.slice(0, tok.index) + fmt2(fils) + v.slice(tok.index + tok[0].length);
    if (nv !== v) node.nodeValue = nv;
  }
  // setAmt with the caller's number format (the AR milestone gaps are whole
  // dirhams, "106", where setAmt would write "106.00")
  function setAmtAs(el, fils, fmt) {
    if (!el || fils == null || !isFinite(fils)) return;
    var w = document.createTreeWalker(el, 4), n, node = null, tok = null;
    while ((n = w.nextNode())) {
      AMT.lastIndex = 0;
      var m, last = null;
      while ((m = AMT.exec(n.nodeValue))) last = m;
      if (last) { node = n; tok = last; }
    }
    if (!node) return;
    var v = node.nodeValue;
    var nv = v.slice(0, tok.index) + fmt(fils) + v.slice(tok.index + tok[0].length);
    if (nv !== v) node.nodeValue = nv;
  }

  /* ---------- 1) mirrors ---------- */
  var sub = form.querySelector('[data-subtotal]');
  function mirror() {
    if (!sub) return;
    var txt = sub.textContent;
    var els = form.querySelectorAll('[data-cb2-total], [data-cb2-cta]');
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== txt) els[i].textContent = txt;
  }
  // a refresh requested while a read is in flight is QUEUED, never dropped:
  // with the engine on, the in-flight read can return the interim cart (floor
  // only) and the follow-up read is what lands the settled numbers
  var t = null, busy = false, again = false;
  function done() { busy = false; if (again) { again = false; kick(); } }
  function refresh() {
    t = null;
    if (busy) { again = true; return; }
    busy = true;
    again = false;
    window.fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { try { apply(c); } finally { done(); } })
      .catch(done);
  }
  function apply(c) {
        if (marketOn) {
          var sticky = document.querySelector('[data-cb-market-sticky]');
          if (sticky) sticky.hidden = !((c.items || []).some(function (item) { return item.quantity > 0; }));
        }
        var itemsN = 0, gifts = [], giftFinal = 0, giftOrig = 0;
        (c.items || []).forEach(function (i) {
          if (i.properties && i.properties._cb2_gift) { gifts.push(i); giftFinal += i.final_line_price || 0; giftOrig += i.original_line_price || 0; }
          else itemsN += i.quantity || 0;
        });
        var row = form.querySelector('[data-cb2-items]');
        if (row) {
          var lab = row.querySelector('[data-cb2-items-label]');
          var tl = (row.dataset.tItems || '').replace('[count]', itemsN);
          if (lab && tl && lab.textContent !== tl) lab.textContent = tl;
          var orig = row.querySelector('[data-cb2-orig]');
          if (orig) {
            setAmt(orig, c.original_total_price || 0);
            orig.classList.toggle('is-struck', (c.total_price || 0) < (c.original_total_price || 0));
          }
        }
        // free-gifts row: count from the carted gift lines, worth from the
        // Liquid-rendered variant->fils map (a missing lookup drops the
        // figure — plain truthful count, never a partial worth)
        var g = form.querySelector('[data-cb2-gifts]');
        if (g) {
          var n = 0, worth = 0, miss = false, map = {};
          try { map = JSON.parse(g.dataset.worths || '{}') || {}; } catch (e) { map = {}; }
          gifts.forEach(function (i) {
            n += i.quantity || 0;
            var w = Number(map[String(i.variant_id)]);
            if (isFinite(w) && w > 0) worth += w; else miss = true;
          });
          if (!n) g.hidden = true;
          else {
            var lt = n === 1 ? (g.dataset.tG1 || '') : n === 2 ? (g.dataset.tG2 || '') : (g.dataset.tGn || '').replace('[count]', n);
            var lel = g.querySelector('[data-cb2-gifts-label]');
            if (lel && lt && lel.textContent !== lt) lel.textContent = lt;
            var wel = g.querySelector('[data-cb2-gifts-worth]');
            var wt = (!miss && worth > 0) ? (g.dataset.tWorth || '').replace('[amount]', fmt0(worth)) : '';
            if (wel && wel.textContent !== wt) wel.textContent = wt;
            g.hidden = false;
          }
        }
        // delivery row: FREE once the POST-discount base crosses the rail's
        // shipping threshold (the rail JS's exact base), else "at checkout"
        var d = form.querySelector('[data-cb2-delivery]');
        var rail = document.getElementById('cb2-offers-rail');
        if (d && d.dataset.cb2DeliveryLive === '1' && rail && rail.dataset.shipEnabled === 'true') {
          var post = (c.total_price || 0) - giftFinal;
          var on = post >= (parseInt(rail.dataset.shipThreshold, 10) || 0);
          var vel = d.querySelector('[data-cb2-delivery-v]');
          var vt = on ? (d.dataset.tFree || '') : (d.dataset.tCalc || '');
          if (vel && vt && vel.textContent !== vt) vel.textContent = vt;
        }
        // gifts box: the away-card gap and the nudge amount, on the rail's
        // exact bases (gift/discount/tiers PRE-discount, shipping POST) —
        // templates + thresholds are Liquid-rendered data attributes, so no
        // string or threshold lives here. Same-state updates only: once a
        // gap closes (<= 0) the frozen rail's settle() re-renders the box.
        var eligOrig = (c.original_total_price || 0) - giftOrig;
        var eligPost = (c.total_price || 0) - giftFinal;
        var away = document.querySelectorAll('#cb2-offers-gift [data-cb2-away]');
        for (var a = 0; a < away.length; a++) {
          var athr = parseInt(away[a].getAttribute('data-cb2-away-thr'), 10) || 0;
          var agap = athr - eligOrig;
          var aspan = away[a].querySelector('.away');
          var atpl = away[a].getAttribute('data-t-away') || '';
          if (agap > 0 && aspan && atpl) {
            var at = atpl.replace('[amount]', fmt0(agap));
            if (aspan.textContent !== at) aspan.textContent = at;
          }
        }
        var nud = document.querySelector('#cb2-offers-gift [data-cb2-nudge]');
        if (nud) {
          var nthr = parseInt(nud.getAttribute('data-cb2-nudge-thr'), 10) || 0;
          var nbase = nud.getAttribute('data-cb2-nudge-base') === 'post' ? eligPost : eligOrig;
          var ngap = nthr - nbase;
          var ntxt = nud.querySelector('[data-cb2-nudge-txt]');
          var ntpl = nud.getAttribute('data-t-nudge') || '';
          if (ngap > 0 && ntxt && ntpl) {
            var nt = ntpl.replace('[amount]', fmt0(ngap));
            if (ntxt.textContent !== nt) ntxt.textContent = nt;
          }
        }
        // milestone cards (owner 2026-09-30, the live theme's cards): the frozen
        // rail script re-renders them only when a milestone flips
        // locked<->unlocked, so a quantity change WITHIN a state left the fill
        // and "add AED X" / "Only AED X away" stale (290 -> 232 kept saying
        // "add AED 10"). Keep a locked card live on the rail's exact bases; an
        // unlocked card and a crossed threshold are left alone (the crossing is
        // the frozen settle()'s re-render). Integer percent = Liquid's
        // `times: 100 | divided_by: thr`; the gap amount keeps its own format
        // (fmt 2 = EN money "AED 106.00", 0 = the AR whole-dirham "106").
        var cards = document.querySelectorAll('#cb2-offers-rail [data-cb2-bar-thr], #cb2-offers-top [data-cb2-bar-thr]');
        for (var bc = 0; bc < cards.length; bc++) {
          var card = cards[bc];
          if (card.classList.contains('unlocked')) continue;
          var bthr = parseInt(card.getAttribute('data-cb2-bar-thr'), 10) || 0;
          var bbase = card.getAttribute('data-cb2-bar-base') === 'post' ? eligPost : eligOrig;
          if (bthr <= 0 || bbase >= bthr) continue;
          var pct = Math.min(100, Math.floor(bbase * 100 / bthr)) + '%';
          var fill = card.querySelector('[data-cb2-bar-fill]');
          if (fill && fill.style.width !== pct) fill.style.width = pct;
          var gapEl = card.querySelector('[data-cb2-bar-gap]');
          if (gapEl) setAmtAs(gapEl, bthr - bbase, gapEl.getAttribute('data-cb2-bar-fmt') === '0' ? fmt0 : fmt2);
        }
        var q = (c.total_price || 0) / 4, q6 = (c.total_price || 0) / 6;
        var boxes = form.querySelectorAll('[data-cb2-emi4]');
        for (var b = 0; b < boxes.length; b++) {
          var s = '4 × ' + (marketCountry === 'KW' && window.cbKwd ? window.cbKwd.presentment(q, marketConfig.currency) : marketCountry === 'SA' && window.cbSaMoney ? window.cbSaMoney.text(q) : fmt2(q));
          if (boxes[b].textContent !== s) boxes[b].textContent = s;
        }
        // tamara splits in 6 (owner 2026-09-30): theme.js only maintains the
        // /4 .emi_price amount, so every 6-way node — the box and the two
        // sentence amounts — is kept current here. Document-wide on purpose:
        // the sticky belt's sentence sits OUTSIDE #CartPageForm. fmt2 rounds
        // like the Liquid `divided_by: 6.0 | round` that first rendered them.
        var boxes6 = document.querySelectorAll('[data-cb2-emi6]');
        for (var b6 = 0; b6 < boxes6.length; b6++) {
          var s6 = '6 × ' + (marketCountry === 'KW' && window.cbKwd ? window.cbKwd.presentment(q6, marketConfig.currency) : marketCountry === 'SA' && window.cbSaMoney ? window.cbSaMoney.text(q6) : fmt2(q6));
          if (boxes6[b6].textContent !== s6) boxes6[b6].textContent = s6;
        }
        var amts6 = document.querySelectorAll('[data-cb2-emi6-amt]');
        for (var a6 = 0; a6 < amts6.length; a6++) setAmt(amts6[a6], q6);
        // owner 2026-09-30: the tabby card shows the per-instalment AMOUNT only
        // ("AED 50.25", the count sits faded beneath) — same amount-only
        // rewrite as tamara's, document-wide like it
        var amts4 = document.querySelectorAll('[data-cb2-emi4-amt]');
        for (var a4 = 0; a4 < amts4.length; a4++) setAmt(amts4[a4], q);
        mirror();
        foldCheck();
  }
  function kick() { clearTimeout(t); t = setTimeout(refresh, 400); }

  /* ---------- 2) the code fold ---------- */
  var body = document.getElementById('cb2-code-body');
  var link = document.getElementById('cb2-code-link');
  function setOpen(open) {
    if (!body || !link) return;
    body.hidden = !open;
    link.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (link && body) {
    link.addEventListener('click', function () {
      // owner 2026-09-30: the promo box renders OPEN and its heading reads as
      // a static title — a tap must never silently hide the input (nothing
      // would visibly bring it back). Clicking only ever opens + focuses.
      if (body.hidden) setOpen(true);
      var inp = document.getElementById('discount-code');
      if (inp) { try { inp.focus(); } catch (e) {} }
    });
  }
  var lastSig = null;
  function foldCheck() {
    if (!body) return;
    var chips = body.querySelectorAll('.cart_discounts li').length;
    var min = body.querySelector('.cb2-min-msgs');
    var minTxt = min ? min.textContent.replace(/\s+/g, ' ').trim() : '';
    var err = body.querySelector('.custom-discount-form p.error');
    var errOn = !!(err && err.style.display === 'block');
    var sig = chips + '|' + minTxt + '|' + errOn;
    // auto-expand on NEW content (a chip, a min-spend line, the error) so the
    // messages stay visible exactly as today; a manual collapse holds until
    // something new lands
    if ((chips > 0 || minTxt || errOn) && sig !== lastSig && body.hidden) setOpen(true);
    lastSig = sig;
  }
  var ft = null;
  function foldKick() { clearTimeout(ft); ft = setTimeout(foldCheck, 120); }
  var fold = document.getElementById('cb2-code-fold');
  if (fold && typeof MutationObserver === 'function') {
    new MutationObserver(foldKick).observe(fold, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
  }

  function boot() {
    sub = form.querySelector('[data-subtotal]');
    if (sub && typeof MutationObserver === 'function') {
      new MutationObserver(function () { mirror(); kick(); }).observe(sub, { childList: true, characterData: true, subtree: true });
    }
    ['cart:updated', 'cart:build', 'cart:change', 'ajaxProduct:added'].forEach(function (ev) {
      document.addEventListener(ev, kick);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) kick(); });
    mirror();
    foldCheck();
    refresh();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* ---------- 3) milestone-aware recommendations ---------- */
(function () {
  'use strict';
  if (typeof window.fetch !== 'function') return;
  function rootUrl() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  var marketConfig = window.cbMarketConfig;
  var marketCountry = marketConfig && marketConfig.country;
  var marketOn = marketCountry === 'SA' || marketCountry === 'KW';
  function fmtA(v) {
    return (Math.round(v) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(/\.00$/, '');
  }
  function boot() {
    var root = document.querySelector('.cb2-reco');
  function marketPrice(cents) {
    if (marketCountry === 'KW') return window.cbKwd ? window.cbKwd.presentment(Number(cents), marketConfig.currency) : '';
    if (marketCountry === 'SA') return window.cbSaMoney ? window.cbSaMoney.text(cents) : '';
    return 'AED ' + fmtA(cents);
  }
  function marketProductUrl(url, handle) {
    if (!marketOn) return url;
    return rootUrl() + 'products/' + encodeURIComponent(handle);
  }
    var row = root && root.querySelector('[data-cb2-reco-row]');
    if (!root || !row) return;
    var rail = document.getElementById('cb2-offers-rail');
    // the shopper's NEXT milestones, from the rail's OWN data attributes and
    // the rail JS's exact bases (ship POST-discount, the rest PRE-discount)
    function milestones(c) {
      var ms = [];
      if (!rail) return ms;
      var gifts = (c.items || []).filter(function (i) { return i.properties && i.properties._cb2_gift; });
      var giftOrig = 0, giftFinal = 0;
      gifts.forEach(function (i) { giftOrig += i.original_line_price || 0; giftFinal += i.final_line_price || 0; });
      var orig = (c.original_total_price || 0) - giftOrig;
      var post = (c.total_price || 0) - giftFinal;
      var ds = rail.dataset;
      if (!marketOn && ds.shipEnabled === 'true') ms.push({ thr: parseInt(ds.shipThreshold, 10) || 0, base: post, r: root.dataset.rShip || '' });
      if (!marketOn && ds.giftEnabled === 'true' && (ds.giftVariants || '').split(',').filter(Boolean).length) {
        ms.push({ thr: parseInt(ds.giftThreshold, 10) || 0, base: orig, r: root.dataset.rGift || '' });
      }
      if (ds.discEnabled === 'true') ms.push({ thr: parseInt(ds.discThreshold, 10) || 0, base: orig, r: root.dataset.rDisc || '' });
      var tiers = [];
      try { tiers = JSON.parse(ds.giftTiers || '[]') || []; } catch (e) { tiers = []; }
      if (!marketOn && Array.isArray(tiers)) tiers.forEach(function (tr) {
        var thr = parseInt(tr && tr.thr, 10) || 0;
        if (thr > 0 && (tr && tr.v || []).length) ms.push({ thr: thr, base: orig, r: root.dataset.rGift2 || '' });
      });
      return ms.filter(function (m) { return m.thr > 0 && m.base < m.thr; });
    }
    function applyNotes(c) {
      var und = milestones(c);
      var cards = row.querySelectorAll('[data-cb2-reco-card]');
      var noted = [], plain = [];
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var note = card.querySelector('[data-cb2-note]');
        var price = parseInt(card.dataset.price, 10) || 0;
        var crossed = und.filter(function (m) { return m.base + price >= m.thr; });
        var txt = '';
        if (und.length && price > 0) {
          if (crossed.length >= 2) txt = (root.dataset.tNoteBoth || '').replace('[a]', crossed[0].r).replace('[b]', crossed[1].r);
          else if (crossed.length === 1) txt = (root.dataset.tNote || '').replace('[amount]', fmtA(crossed[0].thr)).replace('[reward]', crossed[0].r);
        }
        if (marketOn && txt) txt = root.dataset.tNote || '';
        if (note) {
          if (note.textContent !== txt) note.textContent = txt;
          note.hidden = !txt;
        }
        (txt ? noted : plain).push(card);
      }
      var all = noted.concat(plain);
      for (var j = 0; j < all.length; j++) {
        var o = String(j);
        if (all[j].style.order !== o) all[j].style.order = o;
      }
    }
    var busy = false, t = null, again = false;
    function done() { busy = false; if (again) { again = false; kick(); } }
    function run() {
      t = null;
      if (busy) { again = true; return; }
      busy = true;
      again = false;
      window.fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { try { applyNotes(c); } finally { done(); } })
        .catch(done);
    }
    function kick() { clearTimeout(t); t = setTimeout(run, 500); }
    ['cart:updated', 'cart:build', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, kick); });
    var sub = document.querySelector('#CartPageForm [data-subtotal]');
    if (sub && typeof MutationObserver === 'function') {
      try { new MutationObserver(kick).observe(sub, { childList: true, characterData: true, subtree: true }); } catch (e) {}
    }
    // recently-viewed merge: cb2_recent handles not already in the row, as
    // reduced-opacity cards (the board), capped at 3; stars are skipped (the
    // .js payload has no review metafields — same rule as the old rail)
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
    var have = {};
    row.querySelectorAll('[data-cb2-reco-card]').forEach(function (c) { have[c.dataset.handle] = 1; });
    var recent = [];
    try { recent = JSON.parse(localStorage.getItem('cb2_recent') || '[]') || []; } catch (e) { recent = []; }
    if (!Array.isArray(recent)) recent = [];
    recent = recent.filter(function (h) { return h && !have[h]; }).slice(0, 3);
    var sroot = rootUrl();
    Promise.all(recent.map(function (h) {
      return window.fetch(sroot + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (ps) {
      var added = false;
      ps.filter(Boolean).forEach(function (p) {
        if (!p || !p.available || have[p.handle]) return;
        if (marketOn && window.cbNoShipConfig && (window.cbNoShipConfig.handles || []).indexOf(p.handle) !== -1) return;
        var img = p.featured_image ? ((p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image).split('?')[0] + '?width=360') : '';
        var url = marketProductUrl((p.url || '').split('?')[0], p.handle);
        var one = p.variants && p.variants.length === 1;
        var el = document.createElement('div');
        el.className = 'cb2-reco__card is-recent';
        el.setAttribute('data-cb2-reco-card', '');
        el.setAttribute('data-handle', p.handle);
        el.setAttribute('data-price', String(p.price || 0));
        el.innerHTML = '<a class="cb2-reco__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="cb2-reco__name" dir="auto" href="' + esc(url) + '">' + esc((root.dataset.tRecent || '') + ' · ') + esc(String(p.title || '').slice(0, 40)) + '</a>' +
          '<div class="cb2-reco__foot"><span class="cb2-reco__price" dir="ltr">' + esc(marketPrice(p.price || 0)) + '</span>' +
          (one ? '<button type="button" class="cb2-reco__add" data-cb2-add="' + p.variants[0].id + '">+ ' + esc(root.dataset.tAdd || '') + '</button>'
               : '<button type="button" class="cb2-reco__add" data-cb2-goto="' + esc(url) + '">+ ' + esc(root.dataset.tAdd || '') + '</button>') +
          '</div><div class="cb2-reco__note" data-cb2-note hidden></div>';
        row.appendChild(el);
        have[p.handle] = 1;
        added = true;
      });
      run();
      if (added) { /* notes for the new cards land in the same run */ }
    }).catch(function () { run(); });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
